import { render, staticRenderFns } from "./about.vue?vue&type=template&id=f62b360a&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&id=f62b360a&prod&lang=scss&"
import style1 from "./about.vue?vue&type=style&index=1&id=f62b360a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62b360a",
  null
  
)

export default component.exports